import { useAuth0 } from '@auth0/auth0-react'
import { jwtDecode } from 'jwt-decode'
import { FunctionComponent, ReactElement, useEffect, useState } from 'react'
import { AspenPermissions } from '../utils'
import { CircularProgress } from '@material-ui/core'

export interface PermissionProtectedRouteProps {
    requiredPermissions: AspenPermissions[]
    accessDeniedComponent: ReactElement
    protectedChild: ReactElement
}

export const PermissionProtectedRoute: FunctionComponent<PermissionProtectedRouteProps> = ({
    requiredPermissions,
    accessDeniedComponent,
    protectedChild
}) => {
    const { isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0()
    const [permissions, setPermissions] = useState<string[]>([])
    useEffect(() => {
        getAccessTokenSilently().then((token) => {
            const decodedToken = jwtDecode<{ permissions: string[] }>(String(token))
            setPermissions(decodedToken.permissions || [])
        })
    }, [getAccessTokenSilently])

    if (isLoading) {
        return <CircularProgress className='animate-spin' />
    }

    if (!isAuthenticated) {
        return <>{accessDeniedComponent}</>
    }

    if (requiredPermissions.every((permission) => !permissions?.includes(permission))) {
        return <>{accessDeniedComponent}</>
    }

    return <>{protectedChild}</>
}
